import { render } from "./SetSystemConfig.vue?vue&type=template&id=30c76107"
import script from "./SetSystemConfig.vue?vue&type=script&lang=js"
export * from "./SetSystemConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__